import ConfirmModalView from './confirm_modern_modal.js';

const AlertModalView = ConfirmModalView.extend({

  alertType: 'alert',
  className:'modal hide alert-modal',

  // Overload this method because we always want to resolve!
  handleHidden: function() {
    var me = this;
    if (this._deferred.state() === 'pending') {
      me._deferred.resolve();
    }
  }
});

export default AlertModalView;
